import { render, staticRenderFns } from "./QuaisDatas.vue?vue&type=template&id=4bab33ce"
import script from "./QuaisDatas.vue?vue&type=script&lang=js"
export * from "./QuaisDatas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports